import {
  PATCH_WAREHOUSE_STOCK_ITEM,
  convertParams,
  convertResult,
} from 'app/common/api/requests/food/warehouse/stock/id/adjust/patch'

import { WarehouseStockAdjustParams } from 'app/common/types/warehouse/stock'
import { api } from 'app/api'

export const patchWarehouseStockItem = async (
  params: WarehouseStockAdjustParams,
  signal?: AbortSignal,
) => {
  const res = await api.request(PATCH_WAREHOUSE_STOCK_ITEM, {
    additionalAxiosOptions: {
      signal,
    },
    params,
    error: 'Не удалось изменить одну из записей остатков склада',
    convertions: {
      convertParams,
      convertResult,
    },
  })

  return res
}
